export const getImageUrl = (imageUrl?: string) => {
  if (!imageUrl) return "/default-auction.png";
  if (imageUrl.startsWith("http")) return imageUrl;
  if (imageUrl.startsWith("/uploads/")) return imageUrl;
  return `/uploads/${imageUrl}`;
};
